import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

class HpmsBeneficiaryChangeCardApi extends ComponentAPI<never>{

  @AwesomeEvent
  onDadosPessoaisClick = new ClickEventListener();

}

export default HpmsBeneficiaryChangeCardApi;
